export const asError = (err: unknown) =>
  err instanceof Error
    ? err
    : new Error('non-error thrown:' + JSON.stringify(err), { cause: err });
